define.alias("ember-math-helpers/helpers/atan", "preview-grid/helpers/atan");